import * as constants from "../constants/current-user";

const initialState = {
  currentUser: null,
  isLoading: false,
  errorMessage: "",
};

export default function currentUser(state = initialState, action) {
  switch (action.type) {
    case constants.FETCH_CURRENT_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case constants.FETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentUser: action.payload.currentUser,
      };
    case constants.FETCH_CURRENT_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload.response
          ? JSON.parse(action.payload.response).message
          : "",
      };
    default:
      return state;
  }
}
